module.exports = __webpack_public_path__ + "static/media/illustration-section-02.63d0555d.svg";